"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IpptModel = /** @class */ (function () {
    function IpptModel(id, masterId, indicatorId, periodType, dataPointType, wfStateId, lastActionId, createdUserId, dateCreated, updatedUserId, dateUpdated, additionalFields, data, periodId) {
        this.id = id;
        this.masterId = masterId;
        this.indicatorId = indicatorId;
        this.periodType = periodType;
        this.dataPointType = dataPointType;
        this.wfStateId = wfStateId;
        this.lastActionId = lastActionId;
        this.createdUserId = createdUserId;
        this.dateCreated = dateCreated;
        this.updatedUserId = updatedUserId;
        this.dateUpdated = dateUpdated;
        this.additionalFields = additionalFields;
        this.data = data;
        this.periodId = periodId;
    }
    return IpptModel;
}());
exports.IpptModel = IpptModel;
//# sourceMappingURL=ippt.model.js.map